'use client';

import { useBaseGoatImage, useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';
import { useExportAndCloseAccountTransferDrawer } from '@capsicum/features/account/shared';
import { type ReactNode } from 'react';
import styled from 'styled-components';

export type ExportAndCloseAccountTransferDrawerProps = {
	onClickToWallet: () => void;
	onContinue: () => void;
};

export const ExportAndCloseAccountTransferDrawer = ({
	onClickToWallet,
	onContinue
}: ExportAndCloseAccountTransferDrawerProps) => {
	const { $t } = useIntl();
	const { intlTexts, smartContractPageUrl } = useExportAndCloseAccountTransferDrawer();

	const description = $t('settings.accountManagement.exportAndCloseAccountTransferFirstWarning.explanation', {
		smartContractLink: (content: ReactNode) => (
			<S.SmartContractLink href={smartContractPageUrl} target="_blank">
				{content}
			</S.SmartContractLink>
		)
	});

	const goatAlertImage = useBaseGoatImage('alert');
	const drawerData = {
		buttonText: intlTexts.toWalletButton,
		closeButtonText: intlTexts.closeButton,
		description,
		image: goatAlertImage,
		isButtonFullWidth: true,
		isButtonOnRow: false,
		onButtonPress: onClickToWallet,

		onSecondaryActionOnButtonPress: onContinue,
		secondaryActionButtonText: intlTexts.continueButton,
		testID: 'settings-accountManagement-exportAndCloseAccount-transferFirstInfoDrawer',

		title: intlTexts.title
	};

	return <GenericDrawer {...drawerData} />;
};

namespace S {
	export const SmartContractLink = styled.a`
		${({ theme }) => theme.fonts.text.text3}
		color: ${({ theme }) => theme.colors.text.brand.enabled};
	`;
}
